import { useState } from "react";
import { useDispatch } from "react-redux";

import useClipboard from "../../../utils/hook/useClipboard";

import "./styles.scss";

const CopyButton = ({
  title,
  itemToCopy,
  icon: IconComponent,
  iconWidth = 28,
  iconHeight = 28,
  iconViewbox = null,
  successMessage,
  failureMessage,
  iconColor = "var(--color-blue)",
  iconHoverColor = "var(--dashboard-table-row-hash-icon-hover)",
}) => {
  const copy = useClipboard();

  const [isHovered, setIsHovered] = useState(false);

  const copyHashHandler = (e) => {
    e.stopPropagation();

    const success = successMessage || "Copied to clipboard!";
    const failure = failureMessage || "Failed to copy.";

    const copyText =
      typeof itemToCopy === "string" ? itemToCopy : itemToCopy?.current?.textContent || "";

    copy(copyText, success, failure);
  };

  return (
    <span
      title={title}
      onMouseOver={() => setIsHovered(true)}
      onMouseOut={() => setIsHovered(false)}
      onClick={copyHashHandler}
      className="copy-button__copy">
      {IconComponent ? (
        <IconComponent
          width={iconWidth}
          height={iconHeight}
          color={isHovered ? iconHoverColor : iconColor}
          {...(iconViewbox ? { viewBox: iconViewbox } : {})}
        />
      ) : (
        <span onClick={copyHashHandler}>&#128203;</span>
      )}
      {/* <span
        style={{
          color: isHovered ? iconHoverColor : iconColor,
        }}>
        COPY
      </span> */}
    </span>
  );
};

export default CopyButton;
